import React from 'react'

import { ReactComponent as Lock } from '../../assets/icons/lock.svg'
import { ReactComponent as Unlock } from '../../assets/icons/unlock.svg'

export default function ImageLock({
  paths,
  setPaths,
  yPathsRef,
  lockedCheckKey,
  setSelectionRectPathKeys,
  triggerUpdatePath,
}) {
  const onPointerdown = (e) => {
    if (e.target.id.includes('lock')) {
      let newPaths = structuredClone(paths)
      let selectedKey = e.target.id.substring(e.target.id.indexOf('-') + 1)

      // lock 상태 변경
      newPaths[selectedKey].isLocked = !newPaths[selectedKey].isLocked
      // 동시편집
      const yPath = yPathsRef.current.get(selectedKey)
      if (!yPath) return
      yPath.set('isLocked', newPaths[selectedKey].isLocked)

      // unlock -> lock : selectionRect 비활성화
      if (newPaths[selectedKey].isLocked) {
        setSelectionRectPathKeys([])
      }
      // lock -> unlock : selectionRect 활성화
      else {
        setSelectionRectPathKeys([selectedKey])
      }

      // 아직 Undo/Redo와 같은 추가적으로 업데이트 해줘야하는 요소들 남아있음
    }
  }

  return (
    <>
      {lockedCheckKey && (
        <div
          className='sg-absolute sg-bottom-[100px] sg--translate-x-1/2 sg-left-1/2'
          onPointerDown={onPointerdown}
        >
          <div
            id={`lock-${lockedCheckKey}`}
            className={`sg-flex sg-justify-center sg-items-center sg-gap-2 sg-pl-4 sg-pr-8 sg-py-4 sg-rounded-[8px] sg-border sg-border-sk-border-default sg-bg-sk-white ${
              paths[lockedCheckKey].isLocked ? 'sg-block' : 'sg-hidden'
            } sg-cursor-pointer sg-pointer-events-auto`}
          >
            <Unlock className='sg-pointer-events-none' />
            <div className='sg-pointer-events-none sg-text-body1-regular sg-text-sk-label-info'>
              <p>이미지 잠금해제</p>
            </div>
          </div>

          <div
            id={`unlock-${lockedCheckKey}`}
            className={`sg-flex sg-justify-center sg-items-center sg-gap-2 sg-pl-4 sg-pr-8 sg-py-4 sg-rounded-[8px] sg-border sg-border-sk-border-default sg-bg-sk-white ${
              paths[lockedCheckKey].isLocked ? 'sg-hidden' : 'sg-block'
            } sg-cursor-pointer sg-pointer-events-auto`}
          >
            <Lock className='sg-pointer-events-none' />
            <div className='sg-pointer-events-none sg-text-body1-regular sg-text-sk-label-info'>
              <p>이미지 잠그기</p>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
